import { actionSelectOptions } from "@builder/components/app/Popup/popups/Conditions/utils";
import { Fragment } from "react";

interface ActionMenuProps {
    index: number;
    option: string;
    selectOption: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    isActionOpen: boolean;
    setActionOpen: (value: ((prevState: boolean) => boolean) | boolean) => void;
}

const ActionMenu = ({index, option, selectOption, isActionOpen, setActionOpen}: ActionMenuProps) => {
    return (
        <Fragment key={index}>
            <div
                className={`select-input-option-con trigger ${isActionOpen ? "select-active" : ""}`}
                onClick={() => setActionOpen((prev) => !prev)}
            >
                <img src="/angled-arrow-down.svg" id="actionIcon" />
                {option.charAt(0).toUpperCase() + option.slice(1)}
            </div>
            {isActionOpen &&
                actionSelectOptions.map((actionOption, actionIndex) => (
                    <div
                        className="select-input-option-con bullet-point"
                        key={actionIndex}
                        data-value={actionOption}
                        onClick={selectOption}
                    >
                        {actionOption.charAt(0).toUpperCase() + actionOption.slice(1)}
                    </div>
                ))}
        </Fragment>
    );
};

export default ActionMenu;
